// This file was automatically generated from test.standard.html.
// Please don't edit this file by hand.

goog.provide('el8.template.test.standard');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.button');
goog.require('el8.template.core');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.tab = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol id="', soy.$$escapeHtml(opt_data.name), '-tab-contents" class="el8Section"></ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.widgetWrap = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="widget-entry el8SectionItem"><h4 class="el8SectionHeader"><span class="el8LeftArrowIcon"></span>', soy.$$escapeHtml(opt_data.title), '</h4>', (opt_data.instructions) ? '<div class="el8InstrContainer"><p>' + soy.$$escapeHtml(opt_data.instructions) + '</p></div>' : '', '<', soy.$$escapeHtml(opt_data.tag), ' class="widget-elt"></', soy.$$escapeHtml(opt_data.tag), '></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.simpleListWithActions = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol><li class="actions-trigger el8ItemHover"><div class="el8ItemButtonContainer">');
  el8.template.core.actionsButton(null, output);
  output.append('</div><p class="el8ListText">This is standard text to display the hover actions button.</p></li><li class="actions-trigger el8ItemHover"><div class="el8ItemButtonContainer">');
  el8.template.core.actionsButton(null, output);
  output.append('</div><p class="el8ListText">This is another example of the text with a hover actions button.</p></li></ol><h4 class="el8SectionHeader">Simple List without Actions Button</h4><ol><li><p class="el8ListText">This is standard text without an actions button.</p></li><li><p class="el8ListText">Just a regular list.</p></li></ol><h4 class="el8SectionHeader">Numbered List without Actions Button</h4><ol class="el8NumberList"><li class="el8NumberItem"><div class="el8ItemCount">1</div><p class="el8ListText">This is standard text without an actions button.</p></li><li class="el8NumberItem"><div class="el8ItemCount">2</div><p class="el8ListText">Just a regular numbered list.</p></li></ol><h4 class="el8SectionHeader">Bulleted List without Actions Button</h4><ol><li class="el8BulletText">This is standard text without an actions button.</li><li class="el8BulletText">Just a regular numbered list.</li></ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.feedListWithActions = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ReqActSection"><h3 class="el8AttentionText"><span class="el8Wrap">Requiring Actions<div class="el8HeaderCount el8ReqActCount">5</div></span></h3><ol class="el8Feed"><li class="el8FeedItem el8ItemHover"><div class="el8FeedItemDate"><div class="el8SystemText">Received on:</div>01/01/2012</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttons}, output);
  output.append('</div><div class="el8FeedItemIconLab"></div><p><a>< date collected > - list each lab test that was resulted in lab report</a></p><p class="el8AttentionText">Abnormal: List all of the abnormal test results here, and it should span across multiple lines and it should be ok.</p></div></li><li class="el8FeedItem el8ItemHover"><div class="el8FeedItemDate"><div class="el8SystemText">Saw patient on:</div>01/01/2012</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttons}, output);
  output.append('</div><div class="el8FeedItemIconOrder"></div><p><span class="el8AttentionTagItem el8TagItem">In Progress</span><a>Unsigned Office Visit Note</a> <span class="el8SystemText">-- created by Dr. Bobble 01/01/2012 at 5:30pm</span></p></div></li><li class="el8FeedItem el8ItemHover"><div class="el8FeedItemDate"><div class="el8SystemText">Saw patient on:</div>01/01/2012</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttons}, output);
  output.append('</div><div class="el8FeedItemIconOrder"></div><p><span class="el8AttentionTagItem el8TagItem">In Progress</span><a>Unsigned Non-Visit Note</a> <span class="el8SystemText">-- created by Dr. Bobble 01/01/2012 at 4:30pm</span></p></div></li><li class="el8FeedItem el8ItemHover"><div class="el8FeedItemDate"><div class="el8SystemText">Written on:</div>01/01/2012</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttons}, output);
  output.append('</div><div class="el8FeedItemIconOrder"></div><p><span class="el8AttentionTagItem el8TagItem">In Progress</span><a>Lab Requisition Order</a> INR, Lipid Panel<span class="el8SystemText">-- created by Betty Boo 01/01/2012 at 4:15pm</span></p></div></li><li class="el8FeedItem el8ItemHover"><div class="el8FeedItemDate"><div class="el8SystemText">Sent on:</div>01/01/2012</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttons}, output);
  output.append('</div><div class="el8FeedItemIconMessage"></div><p class="el8AppColor">Message between Me, Staff (group)</p><div class="el8Message"><div class="el8MessageTime">11/28/2011</div><div class="el8MessageText el8PhysicianText"><p class="el8Preserve">This is the original message between people in the practice.</p></div></div><div class="el8FieldTrigger el8StandardFontSize">Reply...</div></div></li></ol></div><div class="el8QueueSection"><h3><span class="el8Wrap">Outstanding Items<div class="el8HeaderCount el8QueueCount">1</div></span></h3><ol class="el8Feed"><li class="el8FeedItem el8ItemHover"><div class="el8FeedItemDate"><div class="el8SystemText">Sent on:</div>01/01/2012</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttons}, output);
  output.append('</div><div class="el8FeedItemIconMessage"></div><p class="el8AppColor">Message between Me, Staff (group)</p><div class="el8Message"><div class="el8MessageTime">12:30pm</div><div class="el8MessageText el8StaffText"><p class="el8Preserve">This is a standard reply to message thread between people in the practice.</p></div></div><div class="el8Message"><div class="el8MessageTime">11/28/2011</div><div class="el8MessageText el8PhysicianText"><p class="el8Preserve">This is the original message between people in the practice.</p></div></div><div class="el8FieldTrigger el8StandardFontSize">Reply...</div></div></li></ol></div><ol class="el8Feed"><li class="el8FeedItem el8ItemHover"><div class="el8FeedItemDate"><div class="el8SystemText">Written on:</div>01/01/2011</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttons}, output);
  output.append('</div><div class="el8FeedItemIconRx"></div><p><span class="el8TagItem">eRx New</span><a>Biaxin 500 mg Tab</a> <span class="el8AppColor">sig:</span> 1 tablet orally 2 times per day, #20, RF x0 <a>view order*</a> <span class="el8SystemText">-- < name of prescriber ></span></p><p><span class="el8TagItem">eRx Refill</span><a>Augmentin 875/125 mg Tab</a> <span class="el8AppColor">sig:</span> 1 BID PC, #20 RF x0 <a>view order</a> <span class="el8SystemText">-- < name of prescriber ></span></p><p><span class="el8TagItem">Doc\'d Refill</span><a>Simvastatin 40 mg Tab</a> <span class="el8AppColor">sig:</span> qDaily, #90 RF x0 <span class="el8AppColor">(name of prescriber)</span> <span class="el8SystemText">-- < name of signer ></span></p></div></li><li class="el8FeedItem el8ItemHover"><div class="el8FeedItemDate"><div class="el8SystemText">Received on:</div>01/01/2011</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttons}, output);
  output.append('</div><div class="el8FeedItemIconLab"></div><p><a>< date collected > - list each lab test that was resulted in lab report</a></p><p class="el8AttentionText">Abnormal: List all of the abnormal test results here, and it should span across multiple lines and it should be ok.</p><ul><li class="el8BulletText">Report note will display here.</li><li class="el8BulletText">Multiple report notes will display here.</li></ul><p class="el8SignoffText">Signed off by Dr. Test Sample 1/1/2011 at 5:45pm</p></div></li><li class="el8FeedItem el8ItemHover"><div class="el8FeedItemDate"><div class="el8SystemText">Received on:</div>01/01/2011</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttons}, output);
  output.append('</div><div class="el8FeedItemIconReport"></div><p><a>Description of Report</a></p><ul><li class="el8BulletText">Report note will display here.</li></ul><p class="el8SignoffText">Signed off by Dr. Test Sample 1/1/2011 at 5:45pm</p></div></li><li class="el8FeedItem el8ItemHover"><div class="el8FeedItemDate"><div class="el8SystemText">Updated on:</div>01/01/2011</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttons}, output);
  output.append('</div><div class="el8FeedItemIconMessage"></div><p class="el8AppColor">Message between Me, Staff (group)</p><div class="el8Message"><div class="el8MessageTime">12:30pm</div><div class="el8MessageText el8StaffText"><p class="el8Preserve">This is a standard reply to message thread between people in the practice.</p></div></div><div class="el8Message"><div class="el8MessageTime">11/28/2011</div><div class="el8MessageText el8PhysicianText"><p class="el8Preserve">This is the original message between people in the practice.</p></div></div><p class="el8SignoffText">Signed off by Dr. Test Sample 1/1/2011 at 5:45pm</p></div></li></ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.listeditorWrap = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="listeditor-wrap"><form><button type="button">Construct Listeditor</button><input type="checkbox" name="editFriendly" /> Edit Friendly<input type="checkbox" name="remove" /> Removable<input type="checkbox" name="sortable" /> Sortable<input type="checkbox" name="actions" /> Actions Buttons<input type="checkbox" name="mindreader" /> ICD9 Mindreader</form><div class="listeditor-content"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.listeditor = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection"><label class="el8FieldShort">XX:</label><ol id="', soy.$$escapeHtml(opt_data.listId), '"></ol></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.multilistWrap = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="multilist-wrap"><form><button type="button">Construct Multilist</button><input type="checkbox" name="isNumbered" checked /> Numbered<input type="checkbox" name="isSortable" /> Sortable</form><div class="multilist-content el8FieldSection"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.multilist = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol id="', soy.$$escapeHtml(opt_data.listId), '"></ol><div class="fieldNoteSection"><textarea class="ml-input"></textarea></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.simpleButton = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<button type="button">Standard Button</button>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.formButtonWithDropdown = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ul class="el8ButtonContainer"><li class="el8ButtonItem"><button type="button">Button 1</button></li><li class="el8ButtonItem"><button class="el8DropdownButton" type="button">Has Dropdown<span class="el8ButtonDropdownIcon el8Show"></span></button></li></ul>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.dialogButtonWithDropdown = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ul class="el8ButtonContainer"><li class="el8LgSpaceButtonItem"><button type="button">Button 1</button></li><li class="el8LgSpaceButtonItem"><button class="el8DropdownButton" type="button">Has Dropdown<span class="el8ButtonDropdownIcon el8Show"></span></button></li></ul>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.seeWriteButton = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ShortcutBar"><div class="el8ShortcutBarPCWriteWrap"><ul class="el8ButtonContainer"><li class="el8ShortcutBarButtonItemAlone"><span class="el8ShortcutBarTitle">Write:</span></li><li class="el8ShortcutBarButtonItemFirst"><button class="el8ShortcutBarButton el8FirstButton" type="button">Sample 1</button></li><li class="el8ShortcutBarButtonItem"><button class="el8ShortcutBarButton el8MiddleButton" type="button">Sample 2</button></li><li class="el8ShortcutBarButtonItemLast"><button class="el8ShortcutBarDropdownButton el8LastButton" type="button">Dropdown<span class="el8ShortcutBarButtonDropdownIcon"></span></button></li><li class="el8ShortcutBarButtonItemAlone"><button class="el8ShortcutBarButton el8AloneButton" type="button">Sample 3</button></li><li class="el8ShortcutBarButtonItemFirst"><button class="el8ShortcutBarButton el8FirstButton" type="button">Sample 4</button></li><li class="el8ShortcutBarButtonItemLast"><button class="el8ShortcutBarDropdownButton el8LastButton" type="button">Dropdown<span class="el8ShortcutBarButtonDropdownIcon"></span></button></li></ul></div><div class="el8ShortcutBarContainer el8ShortcutBarPCSeeWrap"><ul class="el8ButtonContainer"><li class="el8ShortcutBarButtonItemAlone"><span class="el8ShortcutBarTitle">See:</span></li><li class="el8ShortcutBarButtonItemFirst"><button class="el8ShortcutBarButton el8FirstButton" type="button">Sample 5</button></li><li class="el8ShortcutBarButtonItemLast"><button class="el8ShortcutBarButton el8LastButton" type="button">Sample 6</button></li></ul></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.seeWriteButtonWithDropdown = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<button type="button" class="el8ShortcutBarDropdownButton">See/Write Button<span class="el8ShortcutBarButtonDropdownIcon"></span></button>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.linkText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<a class="el8StandardFontSize">this is text that is linked to another item</a>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.abnormalText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8AppText">Style that indicates an <span class="el8AttentionText">abnormal</span> value or an <span class="el8AlertText">alert</span> that user should pay attention to.</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.requiredFieldLabel = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<label class=""><span class="el8FieldRequired">*</span>Field Name:</label>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.staffText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8StaffText">Style that indicates text was written by staff.</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.systemText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8SystemText">Style that indicates text is from application.</p><p class="el8SignoffText">-- Signed off by another provider</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.dateFormats = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var fList32623 = opt_data.formats;
  var fListLen32623 = fList32623.length;
  for (var fIndex32623 = 0; fIndex32623 < fListLen32623; fIndex32623++) {
    var fData32623 = fList32623[fIndex32623];
    output.append('Description: ', soy.$$escapeHtml(fData32623.description), ', Date: ', soy.$$escapeHtml(fData32623.text));
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.mindreaderWrap = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mindreader-wrap"><form><button type="button">Construct Mindreader</button><input type="checkbox" name="showOnFocus" /> Show On Focus<input type="checkbox" name="sections" checked /> Popular and Matches<input type="checkbox" name="hasCountInfo" /> Show Counts</form><div class="mindreader-content el8FieldSection"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.mindreader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form class="el8DialogContainer"><div class="el8FieldSection w40"><label class="el8FieldLong">Med:</label><div class="el8FieldLongLabelPadding el8TextareaWrap"><textarea type="text" class="w100" name="medName"></textarea></div></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.validatorWrap = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="validator-wrap"><form><button type="button">Construct Form with Validation</button><input type="checkbox" name="showErrors" /> Show Error Messages</form><div class="validator-content el8FieldSection"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.test.standard.validator = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="validator-test-form" style="width: 500px"><div class="el8FieldSection"><label class="el8FieldLong el8FieldRequired"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Date:</span></label><div class="el8FieldLongLabelPadding el8TextareaWrap datePickerWrap"><input type="text" class="datePicker" name="date" /></div></div><div class="el8FieldSection"><label class="el8FieldLong el8FieldRequired"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>SSN:</span></label><div class="el8FieldLongLabelPadding el8TextareaWrap"><textarea type="text" class="w100" name="ssn"></textarea></div></div><div class="el8FieldSection"><label class="el8FieldLong">Phone:</label><div class="el8FieldLongLabelPadding el8TextareaWrap"><textarea type="text" class="w100" name="phone"></textarea></div></div><div class="el8FieldSection"><label class="el8FieldLong">Doc Tags:</label><div class="el8FieldLongLabelPadding el8TextareaWrap"><textarea type="text" class="w100" name="tags"></textarea></div></div></form>');
  if (!opt_sb) return output.toString();
};
